<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="addItemTypeModal" persistent max-width="530px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">Add Item Type</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeAddItemTypeModal(), $validator.reset()" class="close"
                  >&times;</v-btn
                >
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert type="success" :value="checkAlert">
                Item added successfully
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex sm7 md7>
                    <v-text-field
                      style="width: 70%"
                      label="Item type*"
                      v-model="addItemTypeData.type_name"
                      :error-messages="errors.collect('Item type')"
                      v-validate="'required'"
                      data-vv-name="Item type"
                    ></v-text-field>
                  </v-flex>

                  <v-flex sm7 md7>
                    <v-text-field
                      style="width: 70%"
                      label="Shipping price*"
                      v-model="addItemTypeData.type_int_shipping_price"
                      :error-messages="errors.collect('Shipping price')"
                      v-validate="'required|decimal:2'"
                      data-vv-name="Shipping price"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeAddItemTypeModal(), $validator.reset()"
                outline
                color="normal"
                >Cancel</v-btn
              >
              <v-btn type="submit" style="height:auto; margin-right: 4%" outline color="primary"
                >Add</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'addItemTypeModal',
    'closeAddItemTypeModal',
    'checkAlert',
    'addItemTypeData',
    'addItemType'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.addItemType()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/addItemType.vue